import { Device, Grid, Theme } from '@livecontrol/core-ui';
import { DateTime } from 'luxon';
import React from 'react';
import type { HTMLAttributes, ReactElement } from 'react';
import Nav from 'react-bootstrap/Nav';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

export enum Tab {
  Live = 'live',
  Upcoming = 'upcoming',
  Past = 'past',
  Favorite = 'favorite',
  Mine = 'mine'
}

type Props = HTMLAttributes<HTMLElement> & {
  tab: Tab;
};

const StyledNav = styled(Nav)`
  padding-bottom: 1px;
  border-bottom: 1px solid var(--white35);

  .nav-link {
    margin-bottom: -2px;
  }
`;

export const Tabber = ({ className, tab }: Props): ReactElement => {
  const history = useHistory();
  const viewport = Theme.useViewport();

  const onSelect = React.useCallback(
    (key?: string | null): void => {
      if (key) {
        history.push(`/events/${key}`);
      }
    },
    [history]
  );

  return (
    <StyledNav className={className} variant='tabs' activeKey={tab} onSelect={onSelect}>
      <Grid gridTemplateColumns='1fr min-content' className='w-100'>
        <div className='d-flex'>
          <Nav.Link key={Tab.Live} eventKey={Tab.Live}>
            Live
          </Nav.Link>
          <Nav.Link key={Tab.Upcoming} eventKey={Tab.Upcoming}>
            Upcoming
          </Nav.Link>
          <Nav.Link key={Tab.Past} eventKey={Tab.Past}>
            Past
          </Nav.Link>
          <Nav.Link key={Tab.Favorite} eventKey={Tab.Favorite}>
            Favorite
          </Nav.Link>
        </div>
        {!Device.isMobile(viewport) && (
          <div className='text-white40 text-nowrap m-auto'>
            <span className='font-weight-bold'>Time Zone:</span> {DateTime.local().toFormat('z')}
          </div>
        )}
      </Grid>
    </StyledNav>
  );
};
